<template>
  <div>
    <b-col>
      <div class="row">
        <div class="col-sm-8">
          <p>
            <strong>DEMANDAS</strong>
          </p>
        </div>
        <div class="col-sm-4 text-right"></div>
      </div>
    </b-col>

    <section class="proj-page-section comments">
      <section
        class="without"
        v-if="!lstDemands.length > 0"
        style="margin-top: 0px"
      >
        <div class="row">
          <figure class="text-center">
            <img src="img/sin_datos.png" alt width="150px" />
          </figure>
        </div>
        <div class="row">
          <div class="col-md-12 text-center">
            <h1>Oops!</h1>
            <h4>
              No hay demandas
              <br />para este deudor.
            </h4>
          </div>
        </div>
      </section>

      <section v-else>
        <b-table
          :hover="true"
          :striped="true"
          :bordered="false"
          :small="false"
          :fixed="false"
          responsive="sm"
          :items="lstDemands"
          :fields="fields"
          :select-mode="'single'"
          selectable
          @row-selected="onRowSelected"
        >
          <template slot="date" slot-scope="data">{{
            formatDate(data.item.date)
          }}</template>

          <template slot="created_at" slot-scope="data">{{
            formatDate(data.item.created_at)
          }}</template>
        </b-table>
      </section>

      <div class="row mb-2" v-if="this.demandSelected.id">
        <div class="col-sm-8"></div>
        <div class="col-sm-4 text-right">
          <button
            class="btn btn-sm btn-primary"
            type="button"
            :disabled="!READ"
            @click="getPDF(demandSelected.id)"
          >
            Descargar Resumen
          </button>
        </div>
      </div>

      <!-- RESUMEN DE LA DEMANDA -->
      <div class="profile-side profile-side-summary" v-if="this.demandSelected.id">
        <section class="box-typical bg-white box-typical-summary">
          <header class="widget-header-dark m-0 p-1">
            Resumen de la demanda
          </header>
          <div class="box-typical-inner">
            <table class="table table-striped ml-0 pl-0">
              <tbody>

                <tr>
                  <th scope="row">Demandante</th>
                  <td class="text-right al-vm">{{customer_name}}</td>
                </tr>

                <tr>
                  <th scope="row">Demandado</th>
                  <td class="text-right al-vm">{{demand_summary.debtor_name}}</td>
                </tr>

                <tr>
                  <th scope="row">Radicado</th>
                  <td class="text-right al-vm">{{demand_summary.number_filed}}</td>
                </tr>

                <tr>
                  <th scope="row">Juzgado De Origen</th>
                  <td class="text-right al-vm">{{demand_summary.origin_juded_name}}</td>
                </tr>

                <tr>
                  <th scope="row">Juzgado Actual</th>
                  <td class="text-right al-vm">{{demand_summary.name}}</td>
                </tr>

                <tr>
                  <th scope="row">Ciudad</th>
                  <td class="text-right al-vm">{{demand_summary.city_name}} ({{demand_summary.zone_name}})</td>
                </tr>

                <tr>
                  <th scope="row">Tipo De Proceso</th>
                  <td class="text-right al-vm">{{demand_summary.demand_type_name}}</td>
                </tr>

                <tr>
                  <th scope="row">Cuantía</th>
                  <td class="text-right al-vm">$ {{total_debt}}</td>
                </tr>

                <tr>
                  <th scope="row">Probabilidad De Éxito</th>
                  <td class="text-right al-vm">{{probability == 'A' ? 'Alto' : probability == 'M' ? 'Medio' : 'Bajo'}}</td>
                </tr>

                <tr>
                  <th scope="row">Fecha De Presentación De La Demanda</th>
                  <td class="text-right al-vm">{{demand_summary._date}}</td>
                </tr>

                <tr>
                  <th scope="row">Fecha De Mandamiento De Pago</th>
                  <td class="text-right al-vm">{{demand_summary.payment_order_date}}</td>
                </tr>

                <tr>
                  <th scope="row">Fecha Notificación Personal</th>
                  <td class="text-right al-vm">{{demand_summary.personal_notification_date}}</td>
                </tr>

                <tr>
                  <th scope="row">Fecha Notificación Por Correo Electrónico</th>
                  <td class="text-right al-vm">{{demand_summary.email_notification_date}}</td>
                </tr>

                <tr>
                  <th scope="row">Fecha Notificación Por Aviso</th>
                  <td class="text-right al-vm">{{demand_summary.notification_notice_date}}</td>
                </tr>

                <tr>
                  <th scope="row">Fecha Emplazamiento</th>
                  <td class="text-right al-vm">{{demand_summary.emplacement_date}}</td>
                </tr>

                <tr>
                  <th scope="row">Fecha Audiencia De Conciliación</th>
                  <td class="text-right al-vm">{{demand_summary.conciliation_hearing_date}}</td>
                </tr>

                <tr>
                  <th scope="row">Fecha Audiencia De Instrucción Y Juzgamiento</th>
                  <td class="text-right al-vm">{{demand_summary.hearing_instruction_judgment_date}}</td>
                </tr>

                <tr>
                  <th scope="row">Fecha Sentencia/Ejecución</th>
                  <td class="text-right al-vm">{{demand_summary.judgment_date}}</td>
                </tr>

                <tr>
                  <th scope="row" style="width: 40%;" >Medidas Cautelares</th>
                  <td class="text-justify al-vm" style="width: 60%;">{{demand_summary._precautionary_measure}}</td>
                </tr>

              </tbody>
            </table>
          </div>
        </section>
      </div>
    </section>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "Summary",
  components: {},
  props: {
    debtor_id: {
      type: String,
      default: null,
    },
    customer_name: {
      type: String,
      default: null,
    },
    total_debt: {
      type: String,
      default: null,
    },
    probability: {
      type: String,
      default: null,
    }
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      isCustomer: false,
      // CABECERAS PARA LA TABLA DE LOS AGREEMENTS
      fields: [
        { key: "number", label: "# Interno" },
        { key: "demand_type_name", label: "Tipo" },
        { key: "status_name", label: "Estado" },
        { key: "name", label: "Juzgado" },
        { key: "city_name", label: "Ciudad" },
        { key: "date", label: "Fecha" },
        { key: "user_name", label: "Creado por" },
      ],
      demandSelected: { id: null },
      lstDemands: [],
      errores: [],
      demand_summary: {},

      // ------------------------------------------------------------------------
      // VARIABLES PARA LA GESTÓN DE LAS ACCIONES Y PERMISOS DE CADA USUARIO
      // ------------------------------------------------------------------------
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
    };
  },
  created() {
    this.enabledActions();
    this.getData();
  },

  methods: {
    enabledActions() {
      var auth = localStorage.getItem("auth");
      auth = JSON.parse(auth)[0];
      this.CREATE = auth.create == 1;
      this.READ = auth.read == 1;
      this.UPDATE = auth.update == 1;
      this.DELETE = auth.delete == 1;
    },
    getData() {
      showLoader();
      // CARGAR EL LISTADO DE DEMANDAS
      this.$http
        .get(`${this.$urlApi}demands/debtor/${this.debtor_id}?token=${this.token}`)
        .then(
          (response) => {
            this.lstDemands = response.data.data;
            hideLoader();
          },
          (error) => {
            console.log(error);
            this.errores = getMsgError(error);
            hideLoader();
          }
        );

    },
    formatDate(value) {
      return moment(String(value)).format("DD/MM/YYYY");
    },

    onRowSelected(demands) {
      showLoader();
      this.demandSelected = { id: null };
      console.log("onRowSelected");

      this.demandSelected = demands[0];
      this.$http
        .get(`${this.$urlApi}demands/summary/${this.demandSelected.id}?token=${this.token}`)
        .then(
          (response) => {
            console.log(response);
            this.demand_summary = response.data.data;
            hideLoader();
          },
          (error) => {
            console.log(error);
            this.errores = getMsgError(error);
            hideLoader();
          }
        );

    },

    getPDF(id) {
      showLoader();
      this.$http
        .post(
          `${this.$urlApi}report/demand?token=${this.token}`,
          JSON.stringify({
            demand_id: id,
            customer_name: this.customer_name,
            total_debt: this.total_debt
          }),
          {
            headers: { "Content-Type": "application/json" },
            responseType: "blob"
          }
        )
        .then(
          function(response) {
            console.log(response);
            _downloadFile(response, "resumen-demanda-"+id);
            hideLoader();
          },
          error => {
            console.log(error);
            hideLoader();
          }
        );
    },
  },
};
</script>
